module.exports = __webpack_public_path__ + "images/emoji/european_post_office.e960e8b37bde12e94662.png";